import { NavKey } from "./nav";
import s from "./icons.module.scss";
export type IconName = NavKey | "menu" | "close" | "bell" | "help" | "chevron" | "swap" | "settings" | "signOut" | "eye" | "spinner" | "updown";
const P: Record<IconName, string> = {
  dashboard: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  contacts: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5M17 11a2.5 2.5 0 1 0 0-5M16.5 14.6c2.6.2 4.4 1.9 5 5.4",
  map: "M9 4L3 6.5V20l6-2.5 6 2.5 6-2.5V4l-6 2.5zM9 4v13.5M15 6.5V20",
  routes: "M6 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM8.5 18.5H15a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h6.5",
  reports: "M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6",
  team: "M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 20c.5-3 3-4.8 6-4.8s5.5 1.8 6 4.8M5 10a2 2 0 1 0 0-4M19 10a2 2 0 1 0 0-4",
  billing: "M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3",
  export: "M12 4v12M7 11l5 5 5-5M4 20h16",
  volunteering: "M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z",
  tutorials: "M3 5h18v12H3zM8 21h8M12 17v4M10 8.5v5l4-2.5z",
  adminDashboard: "M4 20V11M9.5 20V5M15 20v-6M20.5 20V9M2 20h20",
  workspaces: "M4 20V8l8-4 8 4v12M9 20v-5h6v5",
  users: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5M17 11a2.5 2.5 0 1 0 0-5M16.5 14.6c2.6.2 4.4 1.9 5 5.4",
  packages: "M3 7l9-4 9 4-9 4zM3 7v10l9 4 9-4V7M12 11v10",
  uploads: "M12 16V4M7 9l5-5 5 5M4 20h16",
  pending: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2",
  centres: "M4 21V10l8-6 8 6v11M9 21v-6h6v6",
  connections: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  suspect: "M12 3l9 16H3zM12 10v4M12 17v.5",
  geocoding: "M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
  donations: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM14.5 9.2c-.4-.8-1.4-1.2-2.5-1.2-1.4 0-2.5.7-2.5 1.8 0 2.6 5 1.2 5 3.8 0 1.1-1.1 1.9-2.5 1.9-1.1 0-2.2-.5-2.6-1.4M12 6v12",
  people: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM2.5 19c.6-3 2.8-4.5 5.5-4.5M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM21.5 19c-.6-3-2.8-4.5-5.5-4.5",
  downloads: "M12 4v12M7 11l5 5 5-5M4 20h16",
  activity: "M3 12h4l3-8 4 16 3-8h4",
  problems: "M12 8a5 5 0 0 1 5 5v2a5 5 0 0 1-10 0v-2a5 5 0 0 1 5-5zM12 8V5M9 5L7 3M15 5l2-2M4 13h3M17 13h3M5 19l2-2M19 19l-2-2",
  billingSettings: "M3 6h18v12H3zM3 10h18M7 15h4",
  accessConsole: "M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6zM9 12l2 2 4-4",
  messages: "M3 6h18v12H3zM3 7l9 6.5L21 7",
  audience: "M3 6h18v12H3zM3 7l9 6.5L21 7M8 21h8",
  preview: "M12 4l2.2 5.1L20 10l-4.3 3.7L17 19.5 12 16.6 7 19.5l1.3-5.8L4 10l5.8-.9z",
  routeFeatures: "M5 16v-4l2-5h10l2 5v4M4 16h16v3H4zM8 16.5h.01M16 16.5h.01",
  menu: "M4 7h16M4 12h16M4 17h16",
  close: "M6 6l12 12M18 6L6 18",
  bell: "M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0",
  help: "M4 13a8 8 0 0 1 16 0M4 13v4h3v-5H4M20 13v4h-3v-5h3M17 17c0 2-2 3-5 3",
  chevron: "M9 6l6 6-6 6",
  swap: "M4 7h13l-3-3M20 17H7l3 3",
  settings: "M10.3 4.3c.4-1.7 3-1.7 3.4 0a1.7 1.7 0 0 0 2.6 1.1c1.5-.9 3.3.8 2.4 2.4a1.7 1.7 0 0 0 1 2.5c1.8.4 1.8 3 0 3.4a1.7 1.7 0 0 0-1 2.6c.9 1.5-.8 3.3-2.4 2.4a1.7 1.7 0 0 0-2.6 1c-.4 1.8-3 1.8-3.4 0a1.7 1.7 0 0 0-2.5-1c-1.6.9-3.3-.9-2.4-2.4a1.7 1.7 0 0 0-1.1-2.6c-1.7-.4-1.7-3 0-3.4a1.7 1.7 0 0 0 1.1-2.5c-.9-1.6.8-3.3 2.4-2.4a1.7 1.7 0 0 0 2.5-1.1zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  signOut: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  spinner: "M12 3a9 9 0 1 1-9 9",
  updown: "M8 10l4-4 4 4M8 14l4 4 4-4",
};
/** Arrow-like glyphs that must mirror in right-to-left languages. */
const DIRECTIONAL: ReadonlySet<IconName> = new Set<IconName>(["signOut", "swap", "chevron"]);
export const Icon = ({ name, size = 20, className }: { name: IconName; size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className={[DIRECTIONAL.has(name) ? s.directional : "", className ?? ""].join(" ").trim() || undefined}>
    <path d={P[name]} />
  </svg>
);
